module.exports = __webpack_public_path__ + "static/design-2c9b63f07f68fc3b02c01ad768b83f48.png";